import axios from "axios";
import type { InternalAxiosRequestConfig } from 'axios'
import { v4 as uuid } from 'uuid'

let baseURL = process.env.REACT_APP_BASE_URL || "http://localhost:8000";
if (baseURL !== "http://localhost:8000") {
  baseURL += "/api";
}
const instance = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    "X-API-Key": "e165e726-e7eb-459a-a37b-d4439301a0e0"
  }
});

const getRefreshTokenURL = () => {
  return "/refresh_token";
};

instance.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  if (config.url === '/upload_production' && config.method === 'post') {
    config.headers = config.headers || {}
    config.headers['Idempotency-Key'] = uuid()
  }
  return config
})

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response.status === 400) {
      return (window.location.href = "/login");
    }

    if (error.response.status === 401) {
      console.log(originalRequest.url);
      if (originalRequest.url == getRefreshTokenURL()) {
        return (window.location.href = "/login");
      } else {
        originalRequest._retry = true;
        try {
          await instance.get(getRefreshTokenURL());
          return instance(originalRequest);
        } catch (refreshError) {
          console.error("Token refresh failed", refreshError);
          return (window.location.href = "/login");
        }
      }
    }

    return Promise.reject(error);
  }
);

export default instance;
